import elapsed from './Elapsed';
export default elapsed;
